import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import { useCallback } from 'react';

export default ({ model, onModelChange, getValue }: CustomFilterProps) => {
  const doesFilterPass = useCallback(
    ({ node }) => {
      return getValue(node).contains(model);
    },
    [model, getValue]
  );

  useGridFilter({ doesFilterPass });

  const onChange = (value: string) => {
    onModelChange(value === '' ? null : value);
  };

  return (
    <div className="ag-filter-body" role="presentation" aria-hidden="false">
      <div
        role="presentation"
        className="ag-text-field ag-input-field ag-filter-from ag-filter-filter"
        aria-hidden="false">
        <div className="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
          <input
            className="ag-input-field-input ag-text-field-input"
            value={model || ''}
            type="text"
            placeholder="Filter..."
            aria-label="Filter Value"
            onChange={({ target: { value } }) => onChange(value)}
          />
        </div>
      </div>
    </div>
  );
};
